import { render, staticRenderFns } from "./PanelsListByTime.vue?vue&type=template&id=552e2bb2"
import script from "./PanelsListByTime.vue?vue&type=script&lang=js"
export * from "./PanelsListByTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports